import React, { useCallback, useEffect, useState } from 'react';
import './styles.scss';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PagePath } from '..';
import { api } from '../../services/api';
import { User } from '../../store/ducks/tables/types';
import ActivityIndicator from '../ActivityIndicator';

const MOCKED_DATA = {
  name: 'Vinicius Oliveira',
  nameOfUser: 'gerentegeral',
  profile: 'Básico',
};

const { REACT_APP_LOCAL_STORAGE_USER_AUTH } = process.env;

const InfoUser: React.FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const token = localStorage.getItem(String(REACT_APP_LOCAL_STORAGE_USER_AUTH));
  const [loading, setLoading] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<User>({} as User);

  const loadUser = useCallback(() => {
    setLoading(true);
    api
      .get(`/admins/users/${id}`, {
        headers: { Authorization: token },
      })
      .then(response => {
        if (response.data.error) {
          setLoading(false);
          toast.error(`${response.data.error}`);
          return;
        }
        setCurrentUser(response.data);
        setLoading(false);
      });
  }, [token]);

  const onNavigationClick = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history],
  );

  useEffect(() => {
    loadUser();
  }, []);

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <>
      <div className="container-body container-info-user">
        <h5>Nome</h5>
        <p> {currentUser.name} </p>
        <h5>Nome de Usuário</h5>
        <p> {currentUser.username} </p>
        <h5>Perfil</h5>
        <p> {MOCKED_DATA.profile} </p>
      </div>
    </>
  );
};

export default InfoUser;
